import { useEffect } from "react";

import { useValues, useFormActions } from "2g-form/hooks";

import { getNextWeekDates } from "b2b/utils/date";

export default function useRezervaceVytvoreniObdobi() {
  const values = useValues() || {};
  const { setValue } = useFormActions();

  useEffect(() => {
    // init/reset obdobi pokud se něco změní
    if (values.produkt) {
      const nextWeek = getNextWeekDates();
      setValue("obdobiOd", nextWeek.datumOd);
      setValue("obdobiDo", nextWeek.datumDo);
    }
  }, [values.zakaznik, values.uzivatel, values.projekt, values.produkt]);

  return {
    visible: Boolean(
      values.zakaznik &&
        values.uzivatel &&
        values.projekt &&
        values.produkt &&
        !values.produkt?.produkt?.bezCasu
    )
  };
}
